import { useEffect, useState } from 'react';
import { useSyncStore } from '../model/sync.store';

const STUCK_MS = 2 * 60 * 1000;

export function SyncIndicator() {
  const online = useSyncStore((state) => state.online);
  const pendingCount = useSyncStore((state) => state.pendingCount);
  const syncing = useSyncStore((state) => state.syncing);
  const lastError = useSyncStore((state) => state.lastError);
  const lastSyncAt = useSyncStore((state) => state.lastSyncAt);

  /** Тик, чтобы «застряла > 2 мин» обновлялась без нового статуса. */
  const [, setTick] = useState(0);
  useEffect(() => {
    if (pendingCount === 0) {
      return;
    }
    const timer = window.setInterval(() => {
      setTick((value) => value + 1);
    }, 30_000);
    return () => {
      window.clearInterval(timer);
    };
  }, [pendingCount]);

  const timeWithoutSuccess =
    lastSyncAt === null ? true : Date.now() - lastSyncAt > STUCK_MS;
  const stuck = pendingCount > 0 && online && (lastError !== null || timeWithoutSuccess);

  const items: string[] = [];
  if (!online) {
    items.push('Офлайн');
  }
  if (pendingCount > 0) {
    items.push(`${pendingCount} несинхронизировано`);
  }
  if (stuck) {
    items.push('Синхронизация застряла — проверьте сеть');
  }
  if (syncing && online && pendingCount === 0) {
    items.push('Синхронизация…');
  }
  if (lastError && online && !stuck) {
    items.push(lastError);
  }

  if (items.length === 0) {
    return (
      <div className="inline-flex items-center gap-2 text-xs text-tg-text-muted" title="Синхронизировано">
        <span className="inline-block h-2 w-2 rounded-full bg-tg-success" />
        <span>В сети</span>
      </div>
    );
  }

  return (
    <div
      className={`inline-flex flex-wrap items-center gap-2 text-xs ${online && !stuck ? 'text-tg-text-secondary' : 'text-tg-warning'}`}
      title={items.join(' · ')}
      role="status"
      aria-live="polite"
    >
      {!online ? (
        <span className="inline-flex items-center gap-1.5 rounded-full border border-tg-warning/40 bg-tg-surface px-2.5 py-1">
          <span className="tg-online-dot inline-block h-2 w-2 rounded-full bg-tg-warning" />
          Офлайн
        </span>
      ) : (
        <span className="inline-flex items-center gap-1.5 rounded-full border border-tg-border-soft bg-tg-surface px-2.5 py-1">
          <span className="inline-block h-2 w-2 rounded-full bg-tg-success" />
          В сети
        </span>
      )}
      {pendingCount > 0 ? (
        <span
          className={`rounded-full border px-2.5 py-1 ${
            stuck
              ? 'border-tg-warning/40 bg-tg-warning/10 text-tg-warning'
              : 'border-tg-accent/40 bg-tg-accent-soft text-tg-accent'
          }`}
        >
          {pendingCount} несинхронизировано
        </span>
      ) : null}
      {stuck ? (
        <span className="rounded-full border border-tg-warning/40 bg-tg-warning/10 px-2.5 py-1 text-tg-warning">
          Синхронизация застряла — проверьте сеть
        </span>
      ) : null}
      {syncing && online && !stuck ? (
        <span className="rounded-full border border-tg-border-soft bg-tg-surface px-2.5 py-1 text-tg-text-secondary">
          Синхронизация…
        </span>
      ) : null}
    </div>
  );
}
